import * as ACT from '../actions/financialActions';

export function financial(state = {}, action) {
    switch (action.type) {


        case ACT.FINANCE_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.FINANCE_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.FINANCE_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.FINANCE_SET_ALL:
            return {
                ...state,
                list: action.data,
            };


        case ACT.FINANCE_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.FINANCE_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };

        case ACT.BANK_GET_ITEM:
            return {
                ...state,
                bankGetItem: action.data,
            };
        case ACT.BANK_SET_ITEM:
            return {
                ...state,
                bankTargetItem: action.data,
            };
        case ACT.BANK_ADD_ITEM:
            return {
                ...state,
                bankAddItem: action.data,
            };
        case ACT.BANK_SET_ALL:
            return {
                ...state,
                bankList: action.data,
            };


        case ACT.BANK_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.BANK_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
